
"use client";

import { usePathname } from "next/navigation";
import type { ReactNode, ComponentProps } from "react";

import GlobalHeaderFooter from "./GlobalHeaderFooter";
import ActionSidebar from "../design-system/organisms/ActionSidebar";
import Loader from "../design-system/molecules/Loader";
import { GeoProvider } from "../context/GeoContext";

type GlobalLayoutProps = ComponentProps<typeof GlobalHeaderFooter>;

type Props = {
  children: ReactNode;
  headerData: GlobalLayoutProps["headerData"];
  footerData: GlobalLayoutProps["footerData"];
};

export default function ConditionalLayout({
  children,
  headerData,
  footerData,
}: Props) {
  const pathname = usePathname();

  const isMaintenance =
    pathname === "/maintenance" ||
    pathname === "/maintenance/";

  // Page maintenance sans les éléments du site
  if (isMaintenance) {
    return <>{children}</>;
  }

  // Layout normal pour les autres pages
  return (
    <GeoProvider>
      <Loader />

      <div className="global-action-sidebar">
        <ActionSidebar />
      </div>

      <GlobalHeaderFooter
        headerData={headerData}
        footerData={footerData}
      >
        {children}
      </GlobalHeaderFooter>
    </GeoProvider>
  );
}
